import { InvoiceServiceInterface } from "interfaces/invoice-service"
import { CommunicationService } from "services/mms/mock/CommunicationService"
import { BaseMmsMockService } from "services/mms/mock/entities-services/BaseMockService"
import { InvoiceInfo } from "types/list-invoice"
import { FetchMockProps } from "types/mms-base"
import {InvoiceSchema} from "mock/invoiceSchema.ts";

export class MockInvoiceService
    extends BaseMmsMockService
    implements InvoiceServiceInterface
{
    constructor(communicationService: CommunicationService) {
        super(communicationService)
    }

    private mapInvoice = (invoice: InvoiceSchema): InvoiceInfo => {
        const invoiceDate = new Date(invoice.issueDate)
        return {
            ...invoice,
            issueDate: invoiceDate.toLocaleDateString(),
            issueDateTimestamp: invoiceDate.getTime(),
        }
    }

    useGetLastInvoice = (): FetchApiProps => {
        const datas: FetchMockProps = {
            mockStatus: 200,
            delay: this.delay,
            controllerFn: ({user}) => {
                const invoicesFromSelfEntity = this.communicationService.invoices
                    .map((i) => ({...i})).filter((i) => {
                        return i.entity_id === user?.entity_id
                    })
                return {
                    data: invoicesFromSelfEntity.map(this.mapInvoice)
                        .reduce((a, b) => (new Date(a.issueDateTimestamp) >  new Date(b.issueDateTimestamp) ? a : b)),
                }
            },
        }
        return this.get(datas)
    }

    useGetListInvoices = (): FetchApiProps => {
        const datas: FetchMockProps = {
            mockStatus: 200,
            delay: this.delay,
            controllerFn: ({user}) => {
                const invoicesFromSelfEntity = this.communicationService.invoices
                    .map((i) => ({...i})).filter((i) => {
                        return i.entity_id === user?.entity_id
                    })
                return {
                    data: invoicesFromSelfEntity.map(this.mapInvoice),
                }
            },
        }
        return this.get(datas)
    }
}
